// Import jQuery explicitly for this module
import $ from 'jquery';
import { initializeDatepickers } from '../../utils/datepicker-config';
import { initializeFormValidation, initializeSubmitSpinner } from '../../utils/form-validation';

$(function () {
  try {
    if ($('.cld-responsive').length > 0) {
      if ($.cloudinary) $.cloudinary.responsive();
    }

    $('#topSearchBox').on('keyup keypress', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });

    $(document).on('click', '[data-click-btn]', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if ($("[href='" + $(this).data('click-href') + "']").closest('.sidebar').length || $(that.data('click-btn')).closest('.sidebar').length) {
        $('body').addClass('sidebar-expanded');
      }
      that = $(this);
      if ($(this).data('click-href') != '') {
        $("[href='" + $(this).data('click-href') + "']").trigger('click');
      }

      setTimeout(function () {
        $(that.data('click-btn')).trigger('click');
      }, 100);
    });

    $(document).on('click', '[data-click-href]', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if ($("[href='" + $(this).data('click-href') + "']").closest('.sidebar').length) {
        $('body').addClass('sidebar-expanded');
      }
      that = $(this);
      if ($(this).data('click-href') != '') {
        $("[href='" + $(this).data('click-href') + "']").trigger('click');
      }
    });

    $(document).on('click', 'span.checkbox', function () {
      $(this).toggleClass('checked');
    })

    if ($('form.search-box select#construction_types').length > 0 && $.fn.select2) {
      $('form.search-box select#construction_types').select2();
    }

    if ($('[data-powertip]').length > 0 && $.fn.powerTip) {
      if (window.matchMedia("(max-width: 1024px)").matches == false) {
        $('body').on('mouseenter mouseleave', '[data-powertip]', function () {
          $('[data-powertip]').powerTip({
            mouseOnToPopup: 'true',
            placement: 'n'
          });
        });
      } else {
        $('body').on('mouseenter mouseleave', '[data-powertip]:not(.button)', function () {
          $('[data-powertip]:not(.button)').powerTip({
            mouseOnToPopup: 'true',
            placement: 'n'
          });
        });
      }

      $('.powertip-warning').on('powerTipRender', function () {
        $('#powerTip').addClass('tip-warning');
      });
      $('.powertip-info').on('powerTipRender', function () {
        $('#powerTip').addClass('tip-info');
      });
      $('.powertip-left').powerTip({
        mouseOnToPopup: 'true',
        placement: 'w'
      });

      $('.powertip-bottom').powerTip({
        mouseOnToPopup: 'true',
        placement: 's'
      });
      $('.powertip-right').powerTip({
        mouseOnToPopup: 'true',
        placement: 'e'
      });
      $('.powertip-topleft').powerTip({
        mouseOnToPopup: 'true',
        placement: 'nw'
      });
      $('.powertip-topright').powerTip({
        mouseOnToPopup: 'true',
        placement: 'ne'
      });
      if (window.matchMedia("(max-width: 1024px)").matches == false) {
        setTimeout(function () {
          $('[data-powertip]').powerTip('hide');
        }, 10000);
      } else {
        setTimeout(function () {
          $('[data-powertip]:not(.button)').powerTip('hide');
        }, 10000);
      }
    }

    // Foundation orbit init and reveal settings are handled by foundation_init.js (Sprockets).
    // Do NOT call $(document).foundation() here — it uses npm jQuery3.

    // Initialize form validation (extracted to form-validation.js)
    initializeFormValidation();

    // Initialize datepickers (extracted to datepicker-config.js)
    initializeDatepickers();

    //
    $(document).on('change', '#office', function () {
      var url = $(this).data('url') + '/' + $(this).val();
      $.get(url);
    });

    $('.reveal-modal').on('opened', function () {
      if ($(this).attr('id') == 'productModal') {
        $('body').find('.reveal-modal-bg').addClass('productOverlay');
      }
      $(window).trigger('resize');
    });

    $("#promotion_link").on('click', function () {
      $('#promotion_box').toggle();
    });

    //Confirm With Reveal Binding dynamically for click but before clicking it
    if ($.fn.confirmWithReveal) {
      $('body').on('mouseenter mouseleave', '.confirm-with-reveal', function () {
        $(".confirm-with-reveal").confirmWithReveal();
      });
    }

    // Initialize submit button spinner (extracted to form-validation.js)
    initializeSubmitSpinner();

    //Autocomplete Binding dynamically for z-index
    $('body').on('focus', 'input[data-autocomplete-source]', function () {
      $(this).on("autocompleteopen", function () {
        $("ul.ui-autocomplete").css('z-index', 1006);
      });
    });

    // custom dropdowns
    $('body').on('click', '.flexible-rolldown ul.f-dropdown li', function () {
      $(this).closest('ul.f-dropdown').find('a').removeClass('selected');
      $(this).find('a').addClass('selected');
      $(this).closest('.flexible-rolldown').find('a.rolldown span').html($(this).find('a span').html());
      $(this).closest('ul.f-dropdown').removeClass("open").css("left", "-99999px");
    });

    $('body').on('click', '.verification_account a.document-link', function () {
      $(this).closest('#accountVerificationModal').foundation('reveal', 'close');
    });

    $('body').on('change', '.custom-file-input', function () {
      filename = $(this).val().split('\\').pop();
      $(this).closest('.upload-section').find('#uploaded_file_name').html(filename);

    });

    // Placeholder for contact page
    $('.reach-offices #drop2 a, .reach-offices#office-selection').on('click', function () {
      $('input, textarea').focus();
      $('#inquiry_name').focus();
    });
  } catch (e) {
    console.warn('[utilities] DOM-ready error:', e.message);
  }
});

$(window).on('load', function () {
  if (!positionStickySupport && $(".sticky-top").length > 0) {
    $(".sticky-top").each(function () {
      if (parseInt($(this).data('minwidth')) < $(window).outerWidth()) {
        $(this).sticky({ topSpacing: $('nav#header').outerHeight(), bottomSpacing: $('#footer').outerHeight() });
      }
    });

    $(window).on('resize', function () {
      $(".sticky-top").each(function () {
        if (parseInt($(this).data('minwidth')) < $(window).outerWidth()) {
          $(this).sticky({ topSpacing: $('nav#header').outerHeight(), bottomSpacing: $('#footer').outerHeight() });
        } else {
          $(this).unstick();
        }
      });
    });
  }

  if ($('ul.portfolio-block-grid').length > 0) {
    setTimeout(function () { $('ul.portfolio-block-grid').change() }, 100);
  }

  if ($('li.has-dropdown').length > 0) {
    $('li.has-dropdown').removeClass('not-click');
    $('ul.dropdown').find('.title.back').remove();

    $('li.has-dropdown').on('click', function (event) {
      event.stopPropagation();
      if ($(this).find('ul.dropdown').is(":visible")) {
        $(this).find('ul.dropdown').fadeOut(200);
        $(this).removeClass('opened');
      }
      else {
        $(this).find('ul.dropdown').fadeIn(200);
        $(this).addClass('opened');
      }
    });

    $('li.has-dropdown ul.dropdown').on('click', function (event) {
      event.stopPropagation();
    });

    $('body').on('click', function () {
      $('li.has-dropdown ul.dropdown').fadeOut(200);
      $('li.has-dropdown').removeClass('opened');
    });
  }

  $('.user-nav.has-dropdown .avatar').on('click', function (event) {
    event.stopPropagation();
    $('.user-nav.has-dropdown').click();
  });

  // This code is for fixing select2 issue for getting clear
  // when clicks anywhere in the document globally
  if ($('.select2-input').length > 0) {
    window.Select2.class.multi.prototype.clearSearch = function () {
      var placeholder = this.getPlaceholder(),
        maxWidth = this.getMaxSearchWidth();
      if (this.search.val() !== "") { } else {
        if (placeholder !== undefined && this.getVal().length === 0 && this.search.val() === "") {
          this.search.val(placeholder).addClass("select2-default");
          this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
        }
      }
    }
  }
  if ($('#company_search_text').length > 0) {
    var header = $('#company_search_text');
    var range = 200;
    $(window).on('scroll', function () {
      var st = $(this).scrollTop();
      header.each(function () {
        var offset = $(this).offset().top;
        var height = $(this).outerHeight();
        offset = offset + height / 2;
        $(this).css({ 'opacity': 1 - (st - offset + range) / range });
      });
    });
  }

});

function transform_cld_img(url, options) {
  return url.replace('/upload/', "/upload/" + options + "/")
}

// Helper function kept for backward compatibility
// Consider migrating callers to use enableAjaxifyParsley from form-validation.js
function enable_ajaxify_parsley() {
  if ($('form.data-parsley-validate').length > 0) {
    $('form.data-parsley-validate').parsley({ 'excluded': ':disabled' }).subscribe('parsley:form:validated', function (parsleyForm) {
      if (parsleyForm.validationResult === true) {
        appendLoader();
      }
    });
  }
}

var positionStickySupport = function () {
  var el = document.createElement('a'),
    mStyle = el.style;
  mStyle.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;";
  return mStyle.position.indexOf('sticky') !== -1;
}();

// Expose to window for cross-module access (Sprockets global → esbuild module scope fix)
window.transform_cld_img = transform_cld_img;
window.enable_ajaxify_parsley = enable_ajaxify_parsley;
